import React from 'react'
import green from '../../Images/Vector 18.png'
import red from '../../Images/Vector 19.png'
import moment from 'moment'
import { Link } from 'react-router-dom'
const IncomeCards = ({ compareSalesByCount, compareSaleByAmount, compareExpensesByAmount, totalSaleAmountOfLastMonth, totalExpensesAmountOfLastMonth }) => {
  return (
    <>
      <div className='card_div_active card_div'>
        <div className='update_head_wrapper'>
          <div className='outer_red_circle_div'>
            <div className='small_red_circle_div'></div>
          </div>
          <p>Update</p>
        </div>
        <p className='update_date_para'>{moment().subtract(1, "months").format("MMMM YYYY")}</p>
        <p className='sales_revenue_para'>Sales {compareSalesByCount.increase ? "increased" : "decreased"} <span style={{ color: compareSalesByCount.increase ? "#BBE961" : "#ff0000" }}>{compareSalesByCount?.value}%</span> from last month</p>
        <Link to="/sales" className='update_date_para' style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          columnGap: '5px',
          textDecoration: "none",
          color: "#868686"
        }}>See Statistics <i class="fa-solid fa-angle-right"></i></Link>
      </div>

      <div className=' card_div'>
        <div className='net_income_head_wrapper'>
          <h5>Total Sales</h5>
          {/* <i class="fa-solid fa-ellipsis"></i> */}
          <Link to="/sales"><i class="fas fa-long-arrow-alt-right"></i></Link>
        </div>
        <h1 className='income_number'><span><i className="fa fa-indian-rupee-sign"></i></span>{totalSaleAmountOfLastMonth}</h1>
        <p className='profit_para'>
          <img src={compareSaleByAmount.increase ? green : red} />
          <span style={{ color: compareSaleByAmount.increase ? "#7BC498" : "#ff0000" }}>{compareSaleByAmount.increase ? "+" : "-"}{compareSaleByAmount?.value}% </span>
          <p> from the last month</p>
        </p>
      </div>

      <div className='card_div'>
        <div className='net_income_head_wrapper'>
          <h5>Total Expenses</h5>
          {/* <i class="fa-solid fa-ellipsis"></i> */}
          <Link to="/expense-report"><i class="fas fa-long-arrow-alt-right"></i></Link>
        </div>
        <h1 className='income_number'><span><i className="fa fa-indian-rupee-sign"></i></span>{totalExpensesAmountOfLastMonth}</h1>
        <p className='profit_para'>
          <img src={compareExpensesByAmount.increase ? green : red} />
          <span style={{ color: compareExpensesByAmount.increase ? "#7BC498" : "#ff0000" }}>{compareExpensesByAmount.increase ? "+" : "-"}{compareExpensesByAmount?.value}% </span>
          <p> from the last month</p>
        </p>
      </div>
    </>
  )
}

export default IncomeCards
